import { useState, createContext, useContext, ReactNode } from 'react';
import { FiltersProvider } from '../../providers/FilterProvider';

export type FilterModules = string;

type FiltersRootContextType = {
	openModule: FilterModules | undefined;
	handleToggle: (module: FilterModules) => void;
	handleOpen: (module: FilterModules) => void;
	handleClose: () => void;
};

const FiltersRootContext = createContext<FiltersRootContextType | undefined>(
	undefined
);

export const FiltersRoot = ({ children }: { children: ReactNode }) => {
	const [openModule, setOpenModule] = useState<FilterModules | undefined>(
		undefined
	);

	const handleToggle = (module: FilterModules) => {
		setOpenModule(state => {
			if (state === module) {
				return undefined;
			}

			return module;
		});
	};

	const handleOpen = (module: FilterModules) => {
		setOpenModule(module);
	};

	const handleClose = () => {
		setOpenModule(undefined);
	};

	return (
		<FiltersRootContext.Provider
			value={{
				openModule,
				handleToggle,
				handleOpen,
				handleClose
			}}
		>
			<FiltersProvider>{children}</FiltersProvider>
		</FiltersRootContext.Provider>
	);
};

export const useFiltersRoot = () => {
	const context = useContext(FiltersRootContext);

	if (!context) {
		throw new Error(
			'Filter must be used within a <Filters.Root /> component'
		);
	}

	return context;
};
